import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const frontmatter = {
  "title": "Equity",
  "lead": "全球在教育的性别平等方面取得了进展，但城乡之间以及贫富之间的差距仍然巨大。"
};
function _createMdxContent(props) {
  const _components = {
    a: "a",
    blockquote: "blockquote",
    h2: "h2",
    li: "li",
    p: "p",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {Figure, HighlightByIndex, IndicatorReference, PageLink, RelatedMaterial, ScrollyArea, ScrollySection, ScrollySticky, Tooltip} = _components;
  if (!Figure) _missingMdxReference("Figure", true);
  if (!HighlightByIndex) _missingMdxReference("HighlightByIndex", true);
  if (!IndicatorReference) _missingMdxReference("IndicatorReference", true);
  if (!PageLink) _missingMdxReference("PageLink", true);
  if (!RelatedMaterial) _missingMdxReference("RelatedMaterial", true);
  if (!ScrollyArea) _missingMdxReference("ScrollyArea", true);
  if (!ScrollySection) _missingMdxReference("ScrollySection", true);
  if (!ScrollySticky) _missingMdxReference("ScrollySticky", true);
  if (!Tooltip) _missingMdxReference("Tooltip", true);
  return _jsxs(_Fragment, {
    children: [_jsx(Figure, {
      id: "HERO_EQUITY"
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsx(_components.p, {
        children: "不让任何人掉队的愿望贯穿于各个可持续发展目标 (SDG)，教育目标的第五个具体目标，即 SDG 4，也明确了这一点。这一侧重点确保了决策者会优先考虑帮助最落后的群体。"
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["为了监测教育差距是否在缩小，我们需要", _jsx(_components.strong, {
        children: "按收入、性别、年龄、种族、民族、移民身份、残疾状况、地理位置和与国家背景相关的其他特征"
      }), "细分的数据，而这些数据是通过家庭调查提供的。"]
    }), "\n", _jsxs(_components.p, {
      children: ["自 2010 年以来，", _jsx(_components.a, {
        href: "https://www.education-inequalities.org/",
        children: "世界教育不平等数据库"
      }), " 一直在采用家庭调查来展示不同国家间的教育差距有多大。本文总结了教育不平等的一些关键事实和趋势，其他方面将在有关", _jsx(PageLink, {
        name: "finance",
        children: "财政"
      }), "的文章中进一步讨论。"]
    }), "\n", _jsx(_components.h2, {
      id: "性别",
      children: "性别"
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.5.1",
      children: [_jsxs(_components.p, {
        children: ["下图展示了群体之间的教育差距，例如女孩和男孩，或者最贫穷和最富有群体之间的差距。它使用", _jsx(Tooltip, {
          title: "平等指数 来衡量教育差距",
          content: "在平等指数中，如果数值接近 0，则表明劣势群体远远落后；数值接近 1 表示平等；数值接近 2 则表示优势群体最落后。例如，平等指数为 0.5 表示女孩的入学率为 30％，而男孩为 60％。平等指数为 1.5 则表示男孩的入学率为 30％，而女孩为 60％。",
          children: "平等指数"
        }), "。"]
      }), _jsxs(_components.p, {
        children: ["尽管这一进展常常遭到忽视，但过去的一代人一直在持续推进", _jsx(Tooltip, {
          title: "性别平等",
          content: "男孩与女孩数量相等",
          children: "性别平等"
        }), "。在世界上许多地方，主要是富有的地区，女孩和年轻女性在学校和大学中的人数超过了男孩和年轻男性。"]
      }), _jsxs(ScrollyArea, {
        children: [_jsx(ScrollySticky, {
          children: _jsx(Figure, {
            id: "GPITREND"
          })
        }), _jsx(ScrollySection, {
          id: "income,0",
          children: _jsxs(_components.p, {
            children: ["任何低于", _jsx(HighlightByIndex, {
              index: "-1",
              children: "灰色阴影"
            }), "区域的线都表明，入学的男孩或年轻男性多于女孩。"]
          })
        }), _jsx(ScrollySection, {
          id: "geo,1",
          children: _jsxs(_components.p, {
            children: ["在", _jsx(HighlightByIndex, {
              index: "0",
              children: "撒哈拉以南非洲地区"
            }), "中，接受高等教育的年轻女性与年轻男性的比例仍然低于 4:5。"]
          })
        }), _jsx(ScrollySection, {
          id: "geo,2",
          children: _jsxs(_components.p, {
            children: [_jsx(HighlightByIndex, {
              index: "2",
              children: "中亚和南亚"
            }), "已经取得了\n巨大进步，从 1990 年女孩教育极度落后，到如今实现了从小学到高等教育的性别平等,\n这主要得益于印度取得的巨大进步。结果，该地区在实现性别平等方面的进展已经超过了", _jsx(HighlightByIndex, {
              index: "0",
              children: "撒哈拉以南非洲地区"
            }), "。"]
          })
        })]
      }), _jsx(_components.p, {
        children: "自 2000 年以来，全球取得了长足的进展。但是，深入到国家层面却发现，差距依然存在：只有三分之二的国家在小学教育入学率方面实现了性别平等，而在初中和高中教育阶段实现这一目标的国家分别不到二分之一和五分之一。"
      }), _jsxs(_components.p, {
        children: ["自 2000 年以来，从小学到高等教育各个阶段，", _jsx(HighlightByIndex, {
          index: "2",
          children: "以牺牲女孩为代价造成巨大不平等"
        }), "的国家占比至少减少了一半，但在小学阶段仍有 3%，初中阶段为 6%，高中阶段则高达 12%。"]
      }), _jsxs(_components.p, {
        children: ["当我们谈论性别平等时，我们决不能忘记男孩。尽管各国在小学教育中", _jsx(HighlightByIndex, {
          index: "0",
          children: "以牺牲男孩为代价造成巨大不平等"
        }), "的情况较少见，但这种情况在高中及以上教育阶段则更为普遍。"]
      }), _jsxs(ScrollyArea, {
        children: [_jsx(ScrollySticky, {
          children: _jsx(Figure, {
            id: "PARITYCOUNT"
          })
        }), _jsx(ScrollySection, {
          children: _jsxs(_components.p, {
            children: ["在这张图表中，条形图的蓝色部分越多越暗，表示有更多国家的", _jsx(HighlightByIndex, {
              index: "0",
              children: "男孩失学率"
            }), "高于女孩。条形图的绿色部分越多越暗，则表示有更多国家的", _jsx(HighlightByIndex, {
              index: "2",
              children: "女孩失学率"
            }), "高于男孩。"]
          })
        }), _jsx(ScrollySection, {
          children: _jsxs(_components.p, {
            children: ["例如，在高等教育阶段，将近三分之二的国家存在", _jsx(HighlightByIndex, {
              index: "0",
              children: "以牺牲男孩为代价造成的极端不平等"
            }), "。"]
          })
        })]
      }), _jsx(_components.h2, {
        id: "财富",
        children: "财富"
      }), _jsx(_components.p, {
        children: "总体而言，女孩和男孩之间的教育差距不如城乡教育差距以及贫富教育差距那样悬殊，家庭调查有助于揭示这些差距。"
      }), _jsxs(_components.p, {
        children: ["例如，在孟加拉国，虽然", _jsx(HighlightByIndex, {
          index: "0",
          children: "最富有"
        }), "群体中有 92% 完成了小学教育，但", _jsx(HighlightByIndex, {
          index: "1",
          children: "最贫穷"
        }), "群体中只有 70％ 完成了小学教育。在尼日利亚，虽然最富有群体中有 94％ 完成了初中教育，但在最贫穷群体中只有 27％ 完成了这一教育阶段。"]
      }), _jsxs(ScrollyArea, {
        children: [_jsx(ScrollySticky, {
          children: _jsx(Figure, {
            id: "PSECWGAP"
          })
        }), _jsx(ScrollySection, {
          children: _jsxs(_components.p, {
            children: ["红点显示了与", _jsx(HighlightByIndex, {
              index: "0",
              children: "最富有"
            }), "儿童或青年相比（以蓝色显示），", _jsx(HighlightByIndex, {
              index: "1",
              children: "最贫穷"
            }), "儿童或青年接受教育的百分比。在图表顶部，您可以切换为从小学到初中及以上的教育阶段。"]
          })
        }), _jsx(ScrollySection, {
          id: "SRB",
          children: _jsxs(_components.p, {
            children: ["在高等教育阶段，中等收入国家的差距最大。例如，在", _jsx(_components.strong, {
              children: "塞尔维亚"
            }), "，最富有群体中有 77％ 接受了各种形式的中学后教育，而在最贫穷群体中这一比例却不到 28％。"]
          })
        }), _jsx(ScrollySection, {
          id: "COL",
          children: _jsxs(_components.p, {
            children: ["在", _jsx(_components.strong, {
              children: "哥伦比亚"
            }), "，这两个比例分别为 64％ 和 7％。"]
          })
        })]
      }), _jsx(_components.p, {
        children: "观察孩子们在接受教育过程中教育差距发生的变化，能更为直观地揭示问题。"
      }), _jsxs(_components.p, {
        children: ["看看下面", _jsx(HighlightByIndex, {
          index: "0",
          children: "贝宁"
        }), "存在的", _jsx(_components.strong, {
          children: "性别"
        }), "差距，它显示了随着教育水平的升高，女孩辍学的严重程度。"]
      }), _jsxs(_components.p, {
        children: ["或者，选择", _jsx(_components.strong, {
          children: "财富"
        }), "可以显示在教育轨迹中，差距是如何以牺牲最贫穷群体为代价而不断扩大的，他们中几乎没有人能接受高中以上的教育。"]
      }), _jsx(Figure, {
        id: "WLGPI"
      })]
    }), "\n", _jsx(_components.p, {
      children: "很少有孩子仅属于某一单一类别，这意味着考虑性别等个体特征与财富等其他因素的相互作用也至关重要，如下一张图表所示。"
    }), "\n", _jsxs(_components.p, {
      children: ["在撒哈拉以南非洲地区，随着教育轨迹的延伸，", _jsx(HighlightByIndex, {
        index: "1",
        children: "最贫穷"
      }), "与", _jsx(HighlightByIndex, {
        index: "0",
        children: "最富有"
      }), "群体之间的差距逐渐扩大。相对于每 100 名接受高等教育的男性，最贫穷女性中接受高等教育的人数不到 35，而最富有女性的人数则接近 100。"]
    }), "\n", _jsx(_components.p, {
      children: "相比之下，在东亚和东南亚，这些点从灰色线向上偏移，因为性别差距是以牺牲最贫穷男性为代价造成的。到了高等教育阶段，最富有女性入学的可能性只比同龄男生高出约 35%，但最贫穷女性则比其高出 50%。"
    }), "\n", _jsx(Figure, {
      id: "GPIBYWEALTH"
    }), "\n", _jsx(_components.h2, {
      id: "结语",
      children: "结语"
    }), "\n", _jsx(_components.p, {
      children: "各国之间以及国内各群体之间存在着令人难以接受的教育不平现象。高质量的分类数据是设计适当战略以减少这些不平等现象的前提条件，最终在我们实现 SDG 4 的过程中，确保不让任何人掉队。"
    }), "\n", _jsx(RelatedMaterial, {
      children: _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://www.education-inequalities.org/",
            children: "全球教育不平等数据库 (WIDE)"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://www.unesco.org/gem-report/en/2024genderreport",
            children: "她心目中的科技 — 2024 年 GEM 性别报告"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://www.savethechildren.org.uk/content/dam/gb/reports/policy/still-left-behind-low-res.pdf",
            children: "仍然被落下 — 拯救儿童会"
          })
        }), "\n"]
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
